
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"210","height":"210","viewBox":"0 0 55.562 55.563"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M27.781 5.936L2.514 49.626h50.535L27.781 5.937zm0 1.787l23.813 41.175H3.969L27.78 7.723z","fill":"none","stroke":"red","stroke-width":"3.9686999999999997","stroke-linejoin":"round","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"red","fill-rule":"evenodd","d":"M25.127 19.611h5.405v17.087h-5.405zM25.127 39.846h5.405v5.171h-5.405z"}})])])
          )
        }
      }
    